<template src="./InviteCooperateComponent.html"></template>
<script>
import InputTextNormal from '@/components/inputs/input-text/normal/InputTextNormal.vue'
import InputPasswordNormal from '@/components/inputs/input-password/normal/InputPasswordNormal.vue'
import InputCheckboxOne from '@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue'
import ButtonLoginComponent from '@/components/buttons/button-login/ButtonLoginConponent.vue'
import { useAccountStore } from '@/stores/account.js'
import {AppConstant} from "@/supports/app.constant.ts";
import {useRoute, useRouter} from "vue-router";
import {useConnectHistoryStore} from "@/stores/connectHistory.js";
import {computed, onMounted, onUpdated, ref} from "vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import App from "@/App.vue";
import CommonService from "@/services/common.service.ts";
import {usePartnerStore} from "@/stores/partner.js";
export default {
  name: 'InviteCooperateComponent',
  computed: {
    AppConstant() {
      return AppConstant
    },
    App() {
      return App
    }
  },
  components: {ButtonAddComponent, ButtonLoginComponent, InputCheckboxOne, InputTextNormal, InputPasswordNormal },
  props: ['login'],
  setup() {
    const accountStore = useAccountStore()
    const connectHistoryStore = useConnectHistoryStore()
    const partnerStore = usePartnerStore()
    const labelRegister = ref('ĐĂNG KÍ NGAY')
    const labelConfirm = ref('XÁC NHẬN')
    const expiredToken = ref(false)
    const isRegister = ref(false)
    const route  = useRoute()
    const token  = route.query.token
    const router = useRouter()

    onMounted(() => {
      const params = {
        token: token,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/connection-history/invite-cooperate-history';
      connectHistoryStore.getInviteCooperateHistory(url, params);
    });

    const connectHistory = computed(() => {
      return connectHistoryStore.connectHistory;
    });

    onUpdated(() => {
      expiredToken.value = CommonService.checkTimeExpiredConnect(connectHistoryStore.connectHistory.connect_date)
      isRegister.value = connectHistoryStore.connectHistory?.company_self.company
    })

    async function confirmCooperate() {
      const params = {
        token: token
      }
      const url = AppConstant.URL_API_LOCAL + 'api/partner/connect-confirm';
      const confirm = await partnerStore.confirmCooperate(url, params)
      await CommonService.showAlertPopup({
        title: confirm?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1000,
        width: '800px'
      });
    }

    function registerAccount() {
      router.push({ name: 'Register', query: {token: token}})
    }

    return {
      accountStore,
      connectHistoryStore,
      connectHistory,
      labelRegister,
      expiredToken,
      isRegister,
      labelConfirm,
      partnerStore,
      confirmCooperate,
      registerAccount
    }
  },
}
</script>
<style scoped lang="scss">
.card-save {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  background: url('@/assets/images/login.jpg') 50%;
  padding: 30px 12px;
  .login-main {
    width: 450px;
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 0 37px rgba(8, 21, 66, 0.05);
    margin: 0 auto;
    background-color: #fff;
    label {
      font-size: 14px;
      letter-spacing: 0.4px;
      padding-left: 10px;
      cursor: pointer;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>
